import React, { useEffect, useState } from "react";
import {  Offcanvas } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form"; 

interface props {
    show: any
    handleClose: any
    // AIData: any
}
const RightFilter = ({ show, handleClose }: props) => {
    const { control, setValue } = useForm();


    return (
        <Offcanvas show={show} onHide={handleClose} placement={"end"}  >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="right-bar">
                    <div data-simplebar className="h-100"> 
                        <hr className="mt-0" />
                        <div className="filter-panel p-1">
                            <div className="filter-radio mb-3">
                                <div className="docs-toggles">
                                    <ul className="list-group">
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="container" type="checkbox" />
                                                <label className="form-check-label" >All</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="trigger" type="checkbox" name="trigger" />
                                                <label className="form-check-label" >Not Started</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="inline" type="checkbox" name="inline" />
                                                <label className="form-check-label" >Started</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="autoShow" type="checkbox" name="autoShow" />
                                                <label className="form-check-label" >Completed</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="filter-radio mb-3">
                                <div className="docs-toggles">
                                    <ul className="list-group">
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="container" type="checkbox" />
                                                <label className="form-check-label" >All</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="trigger" type="checkbox" name="trigger" />
                                                <label className="form-check-label" >&lt; 24 Hours</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="inline" type="checkbox" name="inline" />
                                                <label className="form-check-label"  >24 - 48 Hours </label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                                <input className="form-check-input" id="autoShow" type="checkbox" name="autoShow" />
                                                <label className="form-check-label" >&gt; 48 Hours</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="form-group">
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Select Staff</option>
                                    <option>...</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Select Category</option>
                                    <option>...</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Select Sub Category</option>
                                    <option>...</option>
                                </select>
                            </div>
                            <button className="btn btn-primary w-100">Apply</button>
                        </div>

                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default RightFilter;

